<p>For each bidding period there are two Bid Rounds. After each bid round is complete, you will have Winning Bids and Losing Bids (referred to as ‘Current Bids’ after Round 1).</p>
<p>Losing bids (Current bids) from the first bid round are automatically carried over to the next bidding round. You may choose to do one of the following things with your losing bids from Round 1:</p>
<ul>
    <li>Keep the points on the same section(s);</li>
    <li>Increase (<strong>If</strong> you have more points) or decrease the number of points on a section;</li>
    <li>Or, remove the points altogether and reallocate them to another section</li>
</ul>
<p>You may perform the following activities with Lost Bids:</p>
<div class="table-responsive">
    <table class="table table-hover">
        <thead class="thead-">
            <tr>
                <th> Activity </th>
                <th> Description </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td> Discard </td>
                <td> After the final bid processing for a bidding round, delete a "losing" bid from the system (this will prevent you from being placed on the initial class waitlist) -- no points are refunded back. </td>
            </tr>
        </tbody>
    </table>
</div>
